import styled from "styled-components";
import { theme } from "../../../../../../helpers/theme";

const reference1: string = "*Nasz konsultant skontaktuje się z Tobą w celu omówienia szczegółów realizacji. Będziesz mógł ją finalnie potwierdzić lub odrzucić w dalszym etapie procesu.";
const reference2: string = "*Oferta nie jest ofertą ostateczną w rozumieniu Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."

interface FootnotesProps{
    isFinalOffer?:boolean,
}


export const Footnotes = ({isFinalOffer}:FootnotesProps) => {

    return (
        <Container>
            <ReferencesWraper>
                {isFinalOffer? '*Oferta jest ostateczna w rozumieniu ...':
                <>
                    <Reference>{reference1}</Reference>
                    <Reference>{reference2}</Reference>
                </>
                }
            </ReferencesWraper>
        </Container >
    );
};



const Container = styled.div`
padding:18px 0px;
`;

const ReferencesWraper = styled.div`
margin-top:40px;
display:flex;
flex-direction:column;
`;
const Reference = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.normal};
font-size: 12px;
line-height: 18px;
color: ${theme.colors.gray01_secondaryText};
margin-bottom:16px;
`;